<template>
  <div>
    <el-row>
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20">
        <div class="title">
          <h1>道具驱动的虚拟现实叙事</h1>
        </div>
        <div class="picture project12-head">
          <img src="../assets/VR&P-ST.png.webp" />
        </div>
        <div class="paper_published">
          Gong, Q.*, Wang, Z., Chen, Y., Zou, N. (2024). ‘Rhetoric’ in the design process: The role of prop-based virtual reality storytelling in user-centred product conceptual design. Design Journal, 27(6).
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project12_1.jpg.webp" />
          <br /><br /><img src="../assets/project12_2.png.webp" />
        </div>
      </el-col>
      <el-col :span="10">
        <div class="sub-title">1 引言</div>
        <div class="text">
          以用户为中心的产品概念设计（UCPCD）是聚焦用户需求的核心设计流程，包含用户研究与产品定义两大环节。传统共情方法依赖想象、访谈与故事板，缺乏沉浸式感官体验，在还原真实用户场景上存在局限。本研究从“实物计算”视角将 UCPCD 视为一套具备语法规则的过程，提出基于道具的虚拟现实叙事（VR&amp;P‑ST）可作为一种“修辞”手段优化该流程。通过引入“认知对象”的四大特征（保真度、投入度、模糊性、历史性），本研究推演认为：VR&amp;P‑ST 能够提升认知对象的保真度、中和模糊性、增强历史性，进而提升设计师的情感投入度，最终改善其对设计过程的评价与体验。本研究旨在通过实证实验验证 VR&amp;P‑ST 在 UCPCD 中的作用，为以用户为中心的设计提供全新的沉浸式共情方法。
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="sub-title">2 方法</div>
        <div class="text">
          本研究采用组内对照实验设计，选取 15 名具备设计经验的专业设计师，对比其在使用 VR&amp;P‑ST 与不使用 VR&amp;P‑ST 两种条件下开展 UCPCD 的表现。首先基于 Unity 引擎与 HTC VIVE Pro 设备开发 VR 沉浸式叙事系统，通过 3D 打印模块化实体道具构建被动触觉反馈，模拟手持产品的握持、捏取等触感。系统支持角色切换、场景体验、用户故事记录、产品故事创作与前后对比。实验设置四类用户画像（成年男性、成年女性、儿童、老人）与两类场景（办公、居家）。实验过程中，被试使用认知对象材料（共情地图、产品定义表）完成概念设计任务。数据采集包含验证 10 项假设的主观量表、9 名目标用户的产品需求度评分与访谈记录，采用独立样本 t 检验、皮尔逊相关分析进行数据验证。
        </div>
      </el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project12_3.jpg.webp" />
          <br /><br /><img src="../assets/project12_4.jpg.webp" />
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project12_5.jpg.webp" />
          <br /><br /><img src="../assets/project12_6.jpg.webp" />
          <br /><br /><img src="../assets/project12_7.png.webp" />
        </div>
      </el-col>
      <el-col :span="10">
        <div class="sub-title">3 结论</div>
        <div class="text">
          本研究验证了 VR&amp;P‑ST 作为 UCPCD 中的“修辞”手段，可有效优化概念设计流程。它显著提升设计师的用户理解能力、需求转化能力与批判性思维，在保留认知对象模糊性优势的同时，提升其保真度与历史性、中和模糊性带来的弊端。设计师的积极情感投入与上述三项能力显著正相关，并进一步提升其对方法易用性、创意产出、UCD 知识理解的评价，但对设计流程融合度的评价无显著影响。经 VR&amp;P‑ST 产出的设计方案获得多数目标用户更高的需求认可。该方法突破传统用户研究的时空限制、降低成本并强化沉浸式共情。研究存在 VR 物理特性不稳定、道具需配合、适用范围限于手持产品等局限，未来可优化系统、拓展道具类型并在更多产品领域验证普适性。
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20">
      
        <div class="text">
          本研究基于修辞学理论与认知对象四大特征，推导出 VR&amp;P‑ST 的三大核心修辞作用，并延伸出 10 项关联假设，是全文理论核心：
          <br /><br />
          <b>转喻 —— 提升保真度</b>
          <br />
          VR&amp;P‑ST 提供视觉‑触觉一致的沉浸式体验，让设计师与用户在感官层面共情，显著提升设计师对目标用户的理解能力（H1）；而更强的用户理解能力，会显著提升设计师在设计过程中的愉悦感（H4）。
          <br /><br />
          <b>双关 —— 中和模糊性</b>
          <br />
          沉浸式叙事将难以表达的深层用户需求转化为直观行为，显著提升设计师的用户需求转化能力（H2）；需求转化能力越强，设计师在设计过程中的积极情绪越显著（H5）。
          <br /><br />
          <b>对照 —— 增强历史性</b>
          <br />
          系统可可视化、对比前后故事与场景，推动设计师评估、批判与迭代方案，显著提升概念设计批判性思维能力（H3）；批判性思维越强，过程愉悦感越高（H6）。
          <br /><br />
          在此基础上，研究进一步假设：设计师在过程中的愉悦感会正向影响四项设计评价：
          <br /><br />
          提升对概念设计方法易用性的评价（H7）
          <br />提升对创意概念产出的评价（H9）
          <br />提升对 UCD 知识理解水平的评价（H10）
          <br />提升对方法融入现有设计流程的评价（H8）
          <br /><br />
          实验结果支持 9 项假设，仅 H8 不成立，证实 VR&amp;P‑ST 通过塑造认知对象、发挥修辞作用，有效提升以用户为中心的产品概念设计效果。
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20">
        <div class="picture">
          <img src="../assets/project12_9.png.webp" />
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Project12Zh",
};
</script>

<style scoped>
.paper_published {
  margin-top: 24px;
  font-size: 15px;
  color: #333;
  font-weight: 400;
  text-align: justify;
  line-height: 1.9;
  border-bottom: 1px solid #333;
  padding-bottom: 6px;
}
.picture img {
  width: 100%;
}
.picture.project12-head img {
  width: 85%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.sub-title {
  margin-bottom: 20px;
  font-size: 18px;
  color: #333;
  font-weight: 400;
  text-align: justify;
}
.text {
  font-size: 15px;
  color: #333;
  font-weight: 100;
  text-align: justify;
  line-height: 1.9;
}
.abstract {
  margin-top: 40px;
  font-size: 15px;
  color: #333;
  font-weight: 100;
  text-align: justify;
}
.grid-content {
  min-height: 36px;
}
.title {
  margin-top: 100px;
  text-align: center;
}
.title h1 {
  font-size: 30px;
  font-weight: 100;
  letter-spacing: 6px;
  color: #333333;
}
</style>